module.exports = __webpack_public_path__ + "img/6_154.b3433de7.png";